import React from "react";
export const Delete = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => (
  <svg
    className={className}
    onClick={onClick}
    width={20}
    height={20}
    viewBox="0 0 240 240"
  >
    <g id="Group_1823" data-name="Group 1823" transform="translate(0 0.547)">
      <circle
        id="Ellipse_16"
        data-name="Ellipse 16"
        cx={120}
        cy={120}
        r={120}
        transform="translate(0 -0.547)"
        fill="#cbcbcb"
      />
      <g
        id="Group_1825"
        data-name="Group 1825"
        transform="translate(-865.32 -280.887)"
      >
        <path
          id="Path_1990"
          data-name="Path 1990"
          d="M1045.945,447.259a17.729,17.729,0,0,1-17.2,17.2q-6.828,0-12.647-6.069l-32.882-35.411-32.628,35.411q-5.822,6.07-12.649,6.069a17.709,17.709,0,0,1-17.451-17.451q0-6.574,5.564-12.394L960.2,398.949l-31.87-33.134q-5.566-5.817-5.564-12.394a16.36,16.36,0,0,1,5.185-12.142,16.688,16.688,0,0,1,12.014-5.057q7.078,0,12.9,6.069l30.352,32.377,30.605-32.377q5.817-6.07,12.9-6.069a16.7,16.7,0,0,1,12.016,5.057,16.379,16.379,0,0,1,5.185,12.142q0,6.58-5.566,12.394l-32.122,33.134,34.147,35.664Q1045.94,440.434,1045.945,447.259Z"
          transform="translate(0)"
          fill="#636363"
        />
      </g>
    </g>
  </svg>
);
